import { useTranslation } from 'react-i18next';

export default function SupplierCta() {
  const { t } = useTranslation('supplierNetwork');

  return (
    <section className="relative w-full overflow-hidden bg-warm-50">
      <div className="relative flex items-center justify-center px-4 py-14 md:py-20">
        <div className="max-w-2xl text-center">
          <span className="text-xs font-medium text-warm-500 uppercase tracking-[0.15em] mb-4 block">
            {t('cta.label')}
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-ink-700 leading-snug mb-4 md:mb-6">
            {t('cta.title')}
          </h2>
          <p className="text-sm md:text-base text-ink-500 leading-relaxed mb-8 md:mb-10">
            {t('cta.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <a
              href="/get-quote"
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-warm-500 text-white text-sm md:text-base font-semibold hover:bg-warm-600 transition-colors whitespace-nowrap"
            >
              {t('cta.quote')}
              <i className="ri-arrow-right-line" />
            </a>
            <a
              href="/contact"
              className="inline-flex items-center gap-2 px-7 py-3.5 border border-ink-200 text-ink-700 text-sm md:text-base font-semibold hover:border-warm-500 hover:text-warm-600 transition-colors whitespace-nowrap"
            >
              {t('cta.contact')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}